




import Vue, { PropType } from "vue";
import ice from "../../lib/ice";

export interface VueApplyPlanLinkProps {
  href: string;
}

export interface VueApplyPlanLinkData {
  product: string;
}

export default Vue.extend({
  name: "vc-vue-apply-plan-link",
  props: {
    href: {
      type: String as PropType<VueApplyPlanLinkProps["href"]>,
      default: ""
    }
  },
  data(): VueApplyPlanLinkData {
    return {
      product: "paint"
    };
  },
  methods: {
    onClickButton() {
      if (ice.isIce()) {
        ice.callGetLicense(this.product);
        return;
      }

      window.location.href = this.href;
    }
  }
});
